import React from 'react';
const testimonials = [{
  initials: 'CM',
  quote: 'Dejé de perder horas armando entrenamientos. Ahora abro Fútbol Listo 360 y en 5 minutos tengo la sesión lista. Mi U10 mejoró el control y el pase en un mes.',
  name: 'Carlos M.',
  role: 'México'
}, {
  initials: 'RP',
  quote: 'La progresión por categorías es clarísima. Mis chicos del U12 dejaron de aburrirse y ahora compiten con una idea de juego real.',
  name: 'Rodrigo P.',
  role: 'Argentina'
}, {
  initials: 'DS',
  quote: 'Tengo la temporada completa organizada de la primera a la última semana. Pasé de improvisar a planificar todo el año sin estrés.',
  name: 'Diego S.',
  role: 'Colombia'
}, {
  initials: 'ML',
  quote: 'Las fichas de evaluación cambiaron las reuniones con las familias. Ahora hablo con datos y gráficos de progreso de cada jugador.',
  name: 'Martín L.',
  role: 'España'
}, {
  initials: 'AV',
  quote: 'Con la Biblia de Calentamientos reduje las lesiones del equipo casi a cero esta temporada. Un recurso que uso todos los días.',
  name: 'Andrés V.',
  role: 'Chile'
}, {
  initials: 'JR',
  quote: 'Los 101 ejercicios técnicos me dieron variedad infinita. Cada entrenamiento es distinto y los jugadores llegan motivados.',
  name: 'Juan R.',
  role: 'Perú'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-210">
      <div className="max-w-5xl mx-auto" data-id="element-211">
        <div className="text-center mb-12" data-id="element-212">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-213">
            Lo que dicen los{' '}
            <span className="text-[#00A650]" data-id="element-214">entrenadores</span>
          </h2>
          <p className="text-[#5A5A66] text-base font-bold" data-id="element-215">
            ⭐⭐⭐⭐⭐ 4.9/5 · +2.000 entrenadores en todo el mundo
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-216">
          {testimonials.map((t, i) => <div key={i} className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 flex flex-col shadow-sm" data-id="element-217">
              <div className="flex items-center gap-3 mb-4" data-id="element-218">
                <div className="w-10 h-10 rounded-full bg-[#00A650] flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-219">
                  {t.initials}
                </div>
                <div className="text-[#FFD700] text-sm" data-id="element-220">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[#0A0A0A] text-sm font-medium italic leading-relaxed mb-6 flex-1" data-id="element-221">
                "{t.quote}"
              </p>
              <div data-id="element-222">
                <p className="text-[#0A0A0A] font-black text-sm" data-id="element-223">{t.name}</p>
                <p className="text-[#5A5A66] text-xs font-semibold mt-0.5" data-id="element-224">
                  {t.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}